import React from "react";
import FanPage from "../assets/images/About/Fanpage.jpg"
import GlobalDistro from "../assets/images/About/global.jpg"
import ProfileSharing from "../assets/images/About/ProfileSharing.jpg"
import StreamingAndDownloads from "../assets/images/About/streamingAndDownload.jpg"
import Streams from "../assets/images/About/Streams.jpg"
const services = [
  {
    title: "Music Collection & Global Distribution",
    description:
      "Your talent deserves a global stage! We don’t just collect your music; we ensure it reaches every major streaming platform, including Spotify, Apple Music, and Deezer. Our distribution process guarantees that your sound is heard worldwide, giving you the visibility and reach you deserve. No restrictions, no limits—just pure music, delivered everywhere.",
    image: GlobalDistro,
  },
  {
    title: "Real-Time Streaming Insights & Analytics",
    description:
      "Music is more than sound—it's data, and we help you decode it. Our platform aggregates real-time streaming statistics from all major platforms, providing insights into your most played songs, audience demographics, geographic reach, and revenue trends. With this knowledge, you can fine-tune your strategies, target the right audience, and elevate your music career with informed decisions.",
    image: Streams,
  },
  {
    title: "Dedicated Fan Pages for Artists",
    description:
      "Every artist needs a space to connect with fans, and we provide just that! Our dedicated fan pages allow you to showcase your music, biography, and latest releases in one visually stunning, easy-to-navigate hub. Fans can stream your songs, follow updates, and engage with your journey—helping you grow your community and strengthen your brand as an artist.",
    image: FanPage,
  },
  {
    title: "Seamless Profile & Music Sharing",
    description:
      "Going viral starts with the right exposure! Our seamless sharing tools empower you to distribute your artist profile and tracks across social media, blogs, and music websites with just one click. Whether you're promoting a new single or building hype for an album, we ensure your music is accessible to fans, playlist curators, and industry insiders alike.",
    image: ProfileSharing,
  },
  {
    title: "Instant Download & Streaming Links",
    description:
      "Your fans should never struggle to find your music. We provide instant, direct download and streaming links to ensure seamless access to your tracks across all our platforms. Whether fans want to listen online, save for offline playback, or share with friends, our smart links guarantee a smooth, frustration-free experience that keeps them coming back for more.",
    image: StreamingAndDownloads,
  },
];

const AboutUs = () => {
  return (
    <div className="bg-gray-900 text-white min-h-screen flex items-center justify-center">
      <div className="max-w-5xl p-8 bg-gray-800 rounded-lg shadow-lg mt-0 lg:mt-4">
        <h1 className="text-3xl font-bold text-center text-gray-200 mb-6">About Us</h1>
        <p className="text-lg text-gray-300 text-justify mb-8">
          We are more than just a platform—we are the bridge between artists and success. From global distribution to fan engagement, we provide everything you need to thrive in the music industry.
        </p>

        <div className="space-y-12">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} reverse={index % 2 !== 0} />
          ))}
        </div>
      </div>
    </div>
  );
};

const ServiceCard = ({ title, description, image, reverse }) => {
  return (
    <div
      className={`flex flex-col md:flex-row items-center gap-6 ${
        reverse ? "md:flex-row-reverse" : ""
      }`}
    >
      <img src={image} alt={title} className="w-full md:w-1/2 rounded-lg max-w-[350px] shadow-md h-[200px] -mb-5 md:mb-0" />
      <div className="md:w-1/2 text-center md:text-left">
        <h3 className="text-[18.5px] md:text-xl font-semibold text-yellow-500 ">{title}</h3>
        <p className="text-gray-300 mt-2 text-justify">{description}</p>
      </div>
    </div>
  );
};

export default AboutUs;
